var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "92.8468111%",
    y1: "72.2638202%",
    x2: "21.8679919%",
    y2: "28.5388515%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02ABEC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CAEFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon",
    fill: "url(#linearGradient-1)",
    points: "14 0 26.1243557 7 26.1243557 21 14 28 1.87564435 21 1.87564435 7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Home_1706892",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.095673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00808155,0.054363 C6.07102605,0.055713 6.12975255,0.0765675 6.18620655,0.1153005 L11.8862065,4.615305 C12.01735,4.72062 12.035956,4.914975 11.937769,5.041875 C11.840995,5.16693 11.6351485,5.186955 11.5112065,5.08875 L5.99870655,0.738738 L0.48620655,5.08875 C0.36226455,5.186955 0.16207905,5.16618 0.06433155,5.041875 C-0.03268248,4.9185 -0.02225148,4.71354 0.11120655,4.615305 L2.24870655,2.9278005 L2.24870655,0.354363 C2.24872312,0.188684437 2.38302799,0.0543795654 2.54870655,0.054363 L3.74870655,0.054363 C3.91438511,0.0543795654 4.04868998,0.188684437 4.04870655,0.354363 L4.04870655,1.507488 L5.81120655,0.1153005 C5.87797455,0.071316 5.94513705,0.0530505 6.00808155,0.054363 L6.00808155,0.054363 Z M3.44870655,0.654363 L2.84870655,0.654363 L2.84870655,2.454363 L3.44870655,1.9809255 L3.44870655,0.654363 Z M9.74870655,4.0903005 L10.3487066,4.563735 L10.3487066,9.35436 C10.3487066,9.52003857 10.2143851,9.65436 10.0487066,9.65436 L7.49870655,9.65436 C7.33302798,9.65436 7.19872311,9.52003857 7.19870655,9.35436 L7.19870655,6.654375 L4.79870655,6.654375 L4.79870655,9.35436 C4.79868999,9.52003857 4.66438512,9.65436 4.49870655,9.65436 L1.94870655,9.65436 C1.78302798,9.65436 1.64870655,9.52003857 1.64870655,9.35436 L1.64870655,4.563735 L2.24870655,4.0903005 L2.24870655,9.05436 L4.19870655,9.05436 L4.19870655,6.354375 C4.19872311,6.18869643 4.33302798,6.05439156 4.49870655,6.054375 L7.49870655,6.054375 C7.66438512,6.05439156 7.79868999,6.18869643 7.79870655,6.354375 L7.79870655,9.05436 L9.74870655,9.05436 L9.74870655,4.0903005 L9.74870655,4.0903005 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.940e27f8.svg";
export { ForwardRef as ReactComponent };